<template>
  <button
    :class="{'disabled': loading || disabled, 'rounded-circle': !label}"
    :disabled="loading"
    v-bind="$attrs"
    @click="$emit('click')"
  >
    <div class="spinner-grow" v-if="loading"/>

    <slot name="custom" v-if="!loading && customSlot" />

    <div 
      v-else 
      class="row"
      :class="{
        'justify-content-between': icon && label,
        'justify-content-center': icon || label
      }"
    >
      <i v-if="icon && !rightIcon" :class='icon'></i>
      <span id="label" :class="labelClass" v-if="label">{{ label }}</span>
      <i v-if="icon && rightIcon" :class='icon'></i>
    </div>

  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    icon: String,
    label: String,
    labelClass: String || Object,
    customSlot: {
      type: Boolean,
      default: false
    },
    rightIcon: Boolean,
    disabled: Boolean
  }
}
</script>